"use client";

import React from "react";
import { Check, X, ShieldCheck, Zap, Activity, Leaf } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
const benefitBubbles = [];
const comparisonData = [{
  id: 1,
  feature: "Direct Access to Your Doctor",
  burnFlux: true,
  traditional: false
}, {
  id: 2,
  feature: "New Patient Appointments",
  burnFlux: "Same Day or Next Day",
  traditional: "Weeks to Months"
}, {
  id: 3,
  feature: "Transparent Monthly Pricing",
  burnFlux: true,
  traditional: false
}, {
  id: 4,
  feature: "30-60 Minute Appointments",
  burnFlux: true,
  traditional: false
}, {
  id: 5,
  feature: "Communication Method",
  burnFlux: "Direct Text & Email",
  traditional: "Automated Phone Trees"
}, {
  id: 6,
  feature: "Lab Wholesale Pricing",
  burnFlux: true,
  traditional: false
}];
export default function TheBurnFluxAdvantage() {
  return <section data-section-id="188797" id="the-dpc-advantage" className="bg-background relative overflow-hidden py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="mx-auto max-w-3xl text-center mb-16 sm:mb-24">
          <h2 className="font-serif text-4xl font-normal tracking-tight text-foreground sm:text-6xl">
            The Crescent <span className="text-primary-foreground">Advantage</span>
          </h2>
          <p className="mt-6 text-lg leading-8 text-muted-foreground font-sans max-w-2xl mx-auto">
            Experience healthcare as it was meant to be—personal, accessible, and transparently priced without the interference of traditional insurance networks.
          </p>
        </div>

        {}
        

        {}
        <div className="mx-auto max-w-4xl">
          <div className="text-center mb-8">
            <h3 className="font-serif text-3xl font-normal text-foreground">
              Direct Primary Care vs. Traditional
            </h3>
          </div>

          <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-2xl shadow-primary/5">
            <Table>
              <TableHeader>
                <TableRow className="hover:bg-transparent border-border">
                  <TableHead className="w-[40%] font-serif text-xl sm:text-2xl text-foreground py-6 px-6">
                    Key Features
                  </TableHead>
                  <TableHead className="w-[30%] font-serif text-xl sm:text-2xl text-primary bg-primary/5 text-center py-6 px-4">
                    Crescent DPC
                  </TableHead>
                  <TableHead className="w-[30%] font-serif text-xl sm:text-2xl text-muted-foreground bg-muted/30 text-center py-6 px-4">
                    Traditional Care
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {comparisonData.map((row, i) => <TableRow key={row.id} data-index={i} className="hover:bg-muted/10 border-border transition-colors">
                    <TableCell className="font-sans font-medium text-foreground py-5 px-6 text-base sm:text-lg">
                      {row.feature}
                    </TableCell>
                    
                    {}
                    <TableCell className="bg-primary/[0.02] text-center py-5 px-4">
                      {typeof row.burnFlux === "boolean" ? row.burnFlux ? <div className="flex justify-center">
                            <div className="bg-primary p-1 rounded-full shadow-sm">
                              <Check className="size-5 sm:size-6 text-primary-foreground" strokeWidth={3} />
                            </div>
                          </div> : <X className="size-5 sm:size-6 text-muted-foreground mx-auto" /> : <span className="font-sans font-semibold text-primary text-sm sm:text-base">
                          {row.burnFlux}
                        </span>}
                    </TableCell>

                    {}
                    <TableCell className="bg-muted/20 text-center py-5 px-4">
                      {typeof row.traditional === "boolean" ? row.traditional ? <Check className="size-5 sm:size-6 text-foreground mx-auto" /> : <div className="flex justify-center">
                            <X className="size-5 sm:size-6 text-destructive" strokeWidth={2.5} />
                          </div> : <span className="font-sans text-muted-foreground text-sm sm:text-base">
                          {row.traditional}
                        </span>}
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>

        {}
        <div className="mx-auto max-w-4xl mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2">
          {}
          

          {}
          
        </div>
      </div>
    </section>;
}